var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#83858c;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "16.3,24 20.3,15 24.3,24  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.7,
    y1: 22.4,
    x2: 23.2,
    y2: 22.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.7,
    y1: 10.6,
    x2: 17,
    y2: 10.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.4,
    y1: 8,
    x2: 12.4,
    y2: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.9,18.1c0,0,2-1,3.4-2.5s2.8-4.4,2.8-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.3,12.6c0,0,0.7,1.7,1.9,2.9s3.5,2.5,3.5,2.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.d4c86addc6a347033573c174eece4ac7.svg";
export { ForwardRef as ReactComponent };